import TableRow from "@mui/material/TableRow";
import ViewIcon from "../../assets/icon/ViewIcon.svg";
import EditIcon from "../../assets/icons/edit.svg";
import DeleteIcon from "../../assets/icon/deleteIcon.svg";
import { Box, TableCell } from "@mui/material";
import CustomIcon from "../common/CustomIcon";
import { useState } from "react";
import { delete_daily_expense } from "../../features/expense/expensesService";
import AppSnackbar from "../common/AppSnackbar";
import AddExpenseModal from "./addExpenseModal";
import ViewExpenseModal from "./viewExpenseModal";
import { formatExpDate } from "../../utils/utils";
import { ColorPallet } from "../../utils/colorPallet";
import usePermissions from "../../hooks/usePermissions";

interface IProps {
  expense: any;
  setReloadExpenses: any;
}

const ExpenseInnerRow = ({ expense, setReloadExpenses }: IProps) => {
  const [formState, setFormState] = useState({
    openSnackbar: false,
    openDelSnackbar: false,
  });

  const pharmacyId = parseInt(localStorage.getItem("pharmacyId") || "0");
  const [openUpdateSnackbar, setOpenUpdateSnackbar] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const isPermissions = usePermissions();
  const Account_Type = parseInt(
    localStorage.getItem("pharmacy_account_type") || "0",
    10
  );

  const handleUpdateSuccess = () => {
    setOpenUpdateSnackbar(true);
  };

  const deleteExpense = async (pharmacyID: number, expenseID: number) => {
    const dto = {
      pharmacy_id: pharmacyID,
      exp_id: expenseID,
    };

    try {
      const res = await delete_daily_expense(dto);
      if (res?.success) {
        setReloadExpenses?.((prev: boolean) => !prev);
      }
    } catch (error: any) {}
  };

  const handleDelete = () => {
    const confirmed = window.confirm("Are you sure you want to delete?");
    const expenseID = expense?.id;
    if (confirmed) {
      deleteExpense(pharmacyId, expenseID);
      setFormState((prev) => ({ ...prev, openDelSnackbar: true }));
    }
  };

  const handleOpenEditModal = () => {
    setOpenEditModal(true);
  };

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
  };

  const handleOpenViewModal = () => {
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
  };

  const commonTableCellStyles = {
    borderTop: `1px solid ${ColorPallet.borderColor}`,
    borderRight: `1px solid ${ColorPallet.borderColor}`,
    borderBottom: `1px solid ${ColorPallet.borderColor}`,
    "&.MuiTableCell-root": {
      padding: "5px 0px 5px 15px !important",
    },
  };

  return (
    <>
      <TableRow
        sx={{
          borderLeft: `1px solid ${ColorPallet.borderColor}`,
          borderRight: `1px solid ${ColorPallet.borderColor}`,
        }}
      >
        {/* Date - small width */}
        <TableCell
          sx={{
            ...commonTableCellStyles,
            borderLeft: `1px solid ${ColorPallet.borderColor}`,
            width: "10%",
          }}
        >
          {formatExpDate(expense?.expense_date)}
        </TableCell>

        {/* Name - wider */}
        <TableCell sx={{ ...commonTableCellStyles, width: "25%" }}>
          {expense?.name}
        </TableCell>

        {/* Category - wider */}
        <TableCell sx={{ ...commonTableCellStyles, width: "25%" }}>
          {expense?.exp_category?.name}
        </TableCell>

        {/* Amount - small */}
        <TableCell sx={{ ...commonTableCellStyles, width: "10%" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              gap: "10px",
            }}
          >
            <span>{Number(expense?.amount || 0).toLocaleString()}</span>
            <span
              style={{
                fontWeight: 400,
                fontSize: "10px",
                lineHeight: "100%",
                letterSpacing: "0%",
                color: "#1D1F24",
                minWidth: "0px",
                textAlign: "right",
              }}
            >
              PKR
            </span>
          </Box>
        </TableCell>

        {/* Actions */}
        <TableCell
          sx={{
            ...commonTableCellStyles,
            borderRight: `1px solid ${ColorPallet.borderColor}`,
            width: "10%",
          }}
        >
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ cursor: "pointer" }}>
              <CustomIcon
                IconType={ViewIcon}
                title="View"
                onClick={handleOpenViewModal}
              />
            </Box>

            {(Account_Type === 0 ||
              (isPermissions?.edit && Account_Type === 1)) && (
              <Box sx={{ cursor: "pointer" }}>
                <CustomIcon
                  IconType={EditIcon}
                  title="Edit"
                  onClick={handleOpenEditModal}
                />
              </Box>
            )}
            {(Account_Type === 0 ||
              (isPermissions?.delete && Account_Type === 1)) && (
                <Box sx={{ cursor: "pointer" }}>
              <CustomIcon
                IconType={DeleteIcon}
                title="Delete"
                onClick={handleDelete}
              />
            </Box>

              )}
            
          </Box>
        </TableCell>
      </TableRow>

      <AppSnackbar
        message="Deleted Successfully!"
        open={formState.openDelSnackbar}
        handleClose={() =>
          setFormState((prev) => ({
            ...prev,
            openDelSnackbar: false,
          }))
        }
      />

      <AppSnackbar
        message="Updated Successfully!"
        open={openUpdateSnackbar}
        handleClose={() => setOpenUpdateSnackbar(false)}
      />

      {openEditModal && (
        <AddExpenseModal
          setReloadExpenses={setReloadExpenses}
          handleClose={handleCloseEditModal}
          isEdit={true}
          initialData={expense}
          onUpdateSuccess={handleUpdateSuccess}
        />
      )}

      {openViewModal && (
        <ViewExpenseModal
          handleClose={handleCloseViewModal}
          initialData={expense}
        />
      )}
    </>
  );
};

export default ExpenseInnerRow;
